import React, { Component } from 'react'
import { FormControl, Select, MenuItem, TextField } from '@mui/material'

import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

class DefFieldTextSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            item: this.props.item,
            size:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.size
                    ? this.props.item.settings.size
                    : 100,
            regex:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.regex
                    ? this.props.item.settings.regex
                    : null,
        }

        this.onChange = this.onChange.bind(this)
    }

    onChange(event) {
        let item = this.state.item
        if (!item.settings) {
            item.settings = { [event.target.name]: event.target.value }
        }

        item.settings[event.target.name] = event.target.value
        this.setState({ item: item })

        this.props.onChange(event.target.name, event.target.value)
    }

    render() {
        const { kedo } = this.props
        const { item } = this.state

        return (
            <div>
                <h3>{this.props.kedo.t('Settings')}</h3>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {kedo.t('Regular expression')}
                    </FormInputLabel>
                    <Select
                        value={item.settings.regex || ''}
                        name="regex"
                        onChange={this.onChange}
                        label={kedo.t('Regular expression')}
                    >
                        <MenuItem value="">
                            {kedo.t('Select an option')}
                        </MenuItem>
                        <MenuItem value="#^[0-9]*$#i">
                            {kedo.t('Numbers only')}
                        </MenuItem>
                        <MenuItem value="#^[0-9]{4}[A-Z]{2}$#">
                            {kedo.t('Zipcode netherlands')}
                        </MenuItem>
                        <MenuItem value="/^[0-9]{4}$/">
                            {kedo.t('Municipal code')}
                        </MenuItem>
                        <MenuItem value="/^[a-zA-Z]+(([\',. -][a-zA-Z ])?[a-zA-Z]*)*$/">
                            {kedo.t('Denomination')}
                        </MenuItem>
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {kedo.t('Custom regular expression')}
                    </FormInputLabel>
                    <TextField
                        value={item.settings.regex || ''}
                        name="regex"
                        onChange={this.onChange}
                        fullWidth
                        size="small"
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{kedo.t('Size')}</FormInputLabel>
                    <TextField
                        type="number"
                        value={item.settings.size || 100}
                        name="size"
                        onChange={this.onChange}
                        fullWidth
                        size="small"
                    />
                </FormControl>
            </div>
        )
    }
}

export default DefFieldTextSettings
